module.exports = __webpack_public_path__ + "static/linkedneurons-59bb98a33d07f03aae15765d5ce4fae2.jpg";